export default {
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  apiData: {
    roles: [],
    proyectos: [],
    proyectos_keys: [],
    partes: []
  },
  loaded: false,
  pendientes: {
    proyectos: 0
  },
  online: true,
  page: {
    title: ''
  },
  generalAlert: {
    type: 'danger',
    title: '',
    message: '',
    icon: '',
    show: false
  },
  jsonStatic: {},
  version: '1.0.10'
}



// WEBPACK FOOTER //
// ./src/store/state.js